import "./LocaleSelector.css"
import React, {useEffect, useRef, useState} from "react";
import {useCms} from "../../context/CmsContext";
import {useLocation, useNavigate, useSearchParams} from "react-router-dom";
import {useTranslation} from "react-i18next";

export default function LocaleSelector(){
    let navigate = useNavigate();

    const ref = useRef(null);
    const [isOpen, setIsOpen] = useState(false);
    const [searchParams, setSearchParams] = useSearchParams();


    const location = useLocation();
    // const searchParams = new URLSearchParams(location.search);
    const { i18n } = useTranslation();
    const paramLocale = searchParams.get("lng") ?? i18n.language;

    const {localeData} = useCms();

    const trigger = useRef(null)
    const menu = useRef(null)

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (!menu?.current?.contains(event.target) && !trigger?.current?.contains(event.target)) {
                setIsOpen(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
    }, [trigger, menu])

    if(!!localeData.error || !localeData){
        return <></>
    }

    const currentLocale = !!paramLocale && localeData.some(item => item.code === paramLocale) ? localeData.find(item => item.code === paramLocale) : localeData.find(item =>item.isDefault)

    return <>
        {localeData.length > 1 &&
            <div id="locale-wrapper" ref={ref}>
                <button id={"locale-button"} ref={trigger} onClick={() => {setIsOpen(prev => !prev)}}>
                    {currentLocale.name}
                    {isOpen && <img src={`images/account/dropDownIconUp.svg`}
                                    alt={'arrow drop up'} width={24} height={24}/>}
                    {!isOpen && <img src={`images/account/dropDownIconDown.svg`}
                                     alt={'arrow drop down'} width={24} height={24}/>}
                </button>
                {isOpen &&
                    <ul className={"locale-dropdownMenu"}
                        ref={menu}>
                        {localeData.filter(item => item.code !== currentLocale.code).map((item, index) =>
                            <li key={index}
                                className={"locale-dropdownMenu-item"}
                                onClick={() => {
                                    i18n.changeLanguage(item.code)
                                    if(searchParams.has("lng")) {
                                        searchParams.delete("lng");
                                        setSearchParams(searchParams)
                                    }
                                    if(location.pathname === "/CartPage") {
                                        navigate(-1);
                                        setTimeout(() => {
                                            window.location.reload();
                                        }, 100);
                                    }else {
                                        navigate(0)
                                    }
                                    setIsOpen(false);
                                }}>
                                <span>{item.name}</span>
                            </li>
                        )}
                    </ul>
                }
            </div>
        }
    </>
}